module.exports = __webpack_public_path__ + "media/andenes/lampara_anden-bd41000d.webp";